import {createEffect, createEvent, createStore} from 'effector';
import {createGate} from 'effector-react';

import {authorize} from 'api/auth';
import {registration} from 'api/registration';
import {CertData} from 'types/plugins/cadesPlugin';

export const cleanRegisterDataFx = createEffect({
    name: 'cleanRegisterDataFx',
    handler: () => cert$.reset(),
});

export const registrationFx = createEffect({
    name: 'registrationFx',
    handler: registration,
});

export const loginFx = createEffect({
    name: 'loginFx',
    handler: authorize,
});

export const doRegistration = createEvent<{
    login: string;
    password: string;
    saveCredentials: boolean;
}>();
export const doLogin = createEvent<{login: string; password: string; saveCredentials: boolean}>();
export const doLogout = createEvent<boolean>();

export const RegisterGate = createGate('RegisterGate');
export const cleanRegisterData = createEvent();

export const cert$ = createStore<CertData | null>(null);
export const setCert = createEvent<CertData>();

// export const organization$ = createStore<CertLegalPerson | null>(null);
// export const setOrganization = createEvent<CertLegalPerson | null>();

export const registerError$ = createStore<string | null>(null);
export const registerRedirectFromPrevPath$ = createStore<boolean>(true);
